"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocalizationOrigin = exports.AssetRole = exports.AssetTypes = exports.LocalizationStatus = void 0;
var LocalizationStatus;
(function (LocalizationStatus) {
    LocalizationStatus["NOT_STARTED"] = "not_started";
    LocalizationStatus["IN_PROGRESS"] = "in_progress";
    LocalizationStatus["IN_REVIEW"] = "in_review";
    LocalizationStatus["READY"] = "ready";
    LocalizationStatus["NOT_AVAILABLE"] = "not_available";
})(LocalizationStatus || (exports.LocalizationStatus = LocalizationStatus = {}));
var AssetTypes;
(function (AssetTypes) {
    AssetTypes["ACTIVITY"] = "activities";
    AssetTypes["PARTICIPANT_STATUSES"] = "participant_statuses";
    AssetTypes["SIGN_IN_STUDY_NAME_PII"] = "sign_in_study_name_pii";
    AssetTypes["SIGN_IN_STUDY_NAME"] = "sign_in_study_name";
    AssetTypes["PROTOCOL_SCHEDULE"] = "protocol_schedule";
    AssetTypes["SITE_VISIT_SCHEDULE"] = "site_visit_schedule";
    AssetTypes["SIGN_IN_SUPPORT_INFORMATION"] = "sign_in_support_information";
    AssetTypes["RESOURCES"] = "resources";
    AssetTypes["RESOURCES_PDF"] = "resources_pdf";
    AssetTypes["ACTIVITY_NAMES"] = "activity_names";
    AssetTypes["RESOURCE_TITLES"] = "resource_titles";
    AssetTypes["NOTIFICATION_SMS"] = "notification_sms";
    AssetTypes["NOTIFICATION_PUSH_NOTIFICATION"] = "notification_push_notification";
    AssetTypes["NOTIFICATION_EMAIL"] = "notification_email";
    AssetTypes["PRODUCT_STRINGS"] = "product_strings";
})(AssetTypes || (exports.AssetTypes = AssetTypes = {}));
var AssetRole;
(function (AssetRole) {
    AssetRole["SITE"] = "site";
    AssetRole["PARTICIPANT"] = "participant";
    AssetRole["BOTH"] = "both";
})(AssetRole || (exports.AssetRole = AssetRole = {}));
var LocalizationOrigin;
(function (LocalizationOrigin) {
    LocalizationOrigin["USER"] = "user";
    LocalizationOrigin["AI_TRANSLATION"] = "ai_translation";
    LocalizationOrigin["AI_MIGRATION"] = "ai_migration";
})(LocalizationOrigin || (exports.LocalizationOrigin = LocalizationOrigin = {}));
//# sourceMappingURL=types.js.map